// Message contract shared with the host-page loader (public/sure-chat.js).
// Keep both sides in sync when adding a message type.

export const PROTOCOL_VERSION = 1;

export const MSG = {
  PARENT_READY: 'sure_parent_ready',
  CMD: 'sure_cmd',
  STATE: 'sure_state',
  STATE_REQUEST: 'sure_state_request',
  RESIZE: 'resizeChatIframe',
  MESSAGE_POSTED: 'sure_message_posted',
};

export const HOST_ACTIONS = new Set(['open', 'close', 'toggle', 'sync']);

// The loader appends ?launcher=external when the host page renders its own chat
// button. In that mode the host owns open/close and the built-in launcher bubble
// is never rendered, so channelSettings.isFolded no longer drives visibility.
export const IS_EXTERNAL_LAUNCHER = (() => {
  try {
    return new URLSearchParams(window.location.search).get('launcher') === 'external';
  } catch {
    return false;
  }
})();
